var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-12 h-12 flex-shrink-0"},[_c('SkeletonImage',{staticClass:"object-contain w-full h-full",attrs:{"variant":"light","src":_vm.imageSrc},on:{"error":_vm.onError}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }